import { render, staticRenderFns } from "./moders.vue?vue&type=template&id=587b9388"
import script from "./moders.vue?vue&type=script&lang=ts"
export * from "./moders.vue?vue&type=script&lang=ts"
import style0 from "./moders.vue?vue&type=style&index=0&id=587b9388&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports